import { Modal } from "bootstrap";
import "data-confirm-modal";

import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import ActiveStorageUpload from "@excid3/uppy-activestorage-upload";
import Url from "@uppy/url";

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

let uppyInstances = document.querySelectorAll("[data-uppy-doc]") || [];
if (uppyInstances.length > 0) {
  document
    .querySelectorAll("[data-uppy-doc]")
    .forEach((element) => setupUppy(element));
}

function setupUppy(element) {
  let trigger = element.querySelector('[data-behavior="uppy-doc-trigger"]');
  let form = element.closest("form");
  let direct_upload_url = document
    .querySelector("meta[name='direct-upload-url']")
    .getAttribute("content");
  let field_name = element.dataset.uppyDoc;
  trigger.addEventListener("click", (event) => event.preventDefault());

  let uppy = new Uppy({
    autoProceed: true,
    allowMultipleUploads: false,
    logger: Uppy.debugLogger,
    note: "Word and PDF documents only, 500kb or less",
    allowedFileTypes: ["application/pdf, application/msword"],
  });

  uppy.use(ActiveStorageUpload, {
    directUploadUrl: direct_upload_url,
  });

  uppy.use(Dashboard, {
    trigger: trigger,
    inline: false,
    closeAfterFinish: true,
  });

  uppy.on("complete", (result) => {
    // Rails.ajax
    // or show a preview:
    element
      .querySelectorAll("[data-pending-upload]")
      .forEach((element) => element.parentNode.removeChild(element));

    result.successful.forEach((file) => {
      appendUploadedFile(element, file, field_name);
      console.log("done!");
      console.log(element);
      console.log(file);
    });

    uppy.reset();
  });
}

function appendUploadedFile(element, file, field_name) {
  const hiddenField = document.createElement("input");

  hiddenField.setAttribute("type", "hidden");
  hiddenField.setAttribute("name", field_name);
  hiddenField.setAttribute("data-pending-upload", true);
  hiddenField.setAttribute("value", file.response.signed_id);

  element.appendChild(hiddenField);
}

function setPreview(element, file) {
  let preview = element.querySelector('[data-behavior="uppy-doc-preview"]');
  console.log("ready set");
  console.log(preview);
  if (preview) {
    let src = file.preview
      ? file.preview
      : "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSpj0DBTVsaja01_xWh37bcutvpd7rh7zEd528HD0d_l6A73osY";
    preview.src = src;
  }
}
